import { LOGGED_OUT } from "./constants";
import { LoggedOutAction } from "./types";

export const LOGGED_IN = "LOGGED_IN";
export const SET_TOTP_CODE = "SET_TOTP_CODE";
export const SET_SHOW_TOTP_MODAL = "SET_SHOW_TOTP_MODAL";
export const UPDATE_USER_CLAIMS = "UPDATE_USER_CLAIMS";

export interface AuthState {
  token: string;
  TOTPCode: string;
  showTOTPModal: boolean;
  ssoUserInfo?: Record<string, unknown>;
  userClaims?: string[];
}

export interface LoggedInAction {
  type: typeof LOGGED_IN;
  payload: { token: string; ssoUserInfo: AuthState["ssoUserInfo"] };
}

export interface SetTOTPCodeAction {
  type: typeof SET_TOTP_CODE;
  payload: string;
}

export interface SetShowTOTPModalAction {
  type: typeof SET_SHOW_TOTP_MODAL;
  payload: boolean;
}

export interface UpdateUserClaimsActions {
  type: typeof UPDATE_USER_CLAIMS;
  payload: AuthState["userClaims"];
}

export type AuthActionTypes =
  | LoggedInAction
  | LoggedOutAction
  | SetTOTPCodeAction
  | SetShowTOTPModalAction
  | UpdateUserClaimsActions;

const initialState: AuthState = {
  TOTPCode: "",
  showTOTPModal: false,
  token: "",
};

export default function auth(state = initialState, action: AuthActionTypes): AuthState {
  if (action.type === LOGGED_IN) {
    const { token, ssoUserInfo } = action.payload;
    return {
      ...state,
      ssoUserInfo,
      token,
    };
  }
  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  if (action.type === SET_TOTP_CODE) {
    return {
      ...state,
      TOTPCode: action.payload,
    };
  }
  if (action.type === SET_SHOW_TOTP_MODAL) {
    return {
      ...state,
      showTOTPModal: action.payload,
    };
  }
  if (action.type === UPDATE_USER_CLAIMS) {
    return {
      ...state,
      userClaims: action.payload,
    };
  }

  return state;
}
